module.exports = __webpack_public_path__ + "static/media/postregisterP.f887a798.jpg";